import { Payload } from "@utils/http/AxiosAPI";
import { IMSTokenParams, putWithIdToken } from "@utils/http/MSAuthAPI";
import {logger as SentryLogger} from '@sentry/react';
import {ExchangeTypes} from "@views/VehicleExchange/exchangeReasonReducer";

export type VehicleExchangeRequest = { exchangeDocumentId: string };

export interface ExchangeResponseFleetioDetail {
    success_old: boolean;
    vehicle_url_old: string;
    vehicle_description_old: string;
    success_new: boolean;
    vehicle_url_new: string;
    vehicle_description_new: string;
}

export interface ExchangeResponseZohoDetail {
    success: boolean;
    subscription_url: string;
    contact_email: string;
    contact_id: string;
}

export interface ExchangeResponseChargebeeDetail {
    success: boolean;
    subscription_url?: string;
}

/**
 * Only present when the exchange ended a DAMS cross hire.
 *
 * Mirrors VehicleExchangeResponse.Dams in processors/vehicle_exchange.py.
 */
export interface ExchangeResponseDamsDetail {
    ticket_raised: boolean;
    phav_record_id: string;
}

export interface VehicleExchangeResponse {
    exchange_type: ExchangeTypes;
    fleetio: ExchangeResponseFleetioDetail;
    zoho: ExchangeResponseZohoDetail;
    chargebee?: ExchangeResponseChargebeeDetail;
    dams?: ExchangeResponseDamsDetail;
    possible_incorrect_original_vehicle_data: boolean;
    // Price change only - always returned for a PriceChange exchange, absent for the other types.
    // Minor currency (pence/cents) - convert before display
    new_weekly_fee?: number;
}

interface IVehicleExchangeService {
    performVehicleExchange(
        body: VehicleExchangeRequest,
        IDTokenParams: IMSTokenParams
    ): Promise<VehicleExchangeResponse>;
}

export const VehicleExchangeService: IVehicleExchangeService = {
    async performVehicleExchange(body, IDTokenParams) {
        const resp = await putWithIdToken(
            "v1/vehicle-exchange",
            IDTokenParams,
            {}, // no query params
            body
        );
        SentryLogger.info("Exchange result", { request: body, response: resp.data });
        return resp.data;
    }
};
